/* pf-blogpage.js — Mechanik für den Blog-Post: Lesefortschritt, Inhaltsverzeichnis
   aus den Zwischenüberschriften, FAQ-Aufklapper und die Teilen-Knöpfe.

   Der Artikeltext kommt aus dem Shopify-Editor. Statt die Redaktion zu neuen
   Bausteinen zu zwingen, liest dieses Skript die vorhandene Struktur:
     <h2>            → Kapitel im Inhaltsverzeichnis (optional durchnummeriert)
     <blockquote>    → Tipp-Kasten (Icon wird hier ergänzt, Rest macht CSS)
     <h2>Häufige Fragen</h2> + <h3>  → FAQ-Aufklapper
   Damit funktionieren auch alle Altbeiträge ohne Nacharbeit. */
(function () {
  'use strict';

  var ICON_PLUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg>';
  var ICON_TIP = '<svg class="pfblog-tip-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path><path d="M9 18h6"></path><path d="M10 22h4"></path></svg>';

  function slug(text, fallback) {
    var s = (text || '')
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return s || fallback;
  }

  /* ── FAQ: alles unter der Fragen-Überschrift in <details> umbauen ───── */
  function buildFaq(prose, pattern) {
    var re;
    try { re = new RegExp(pattern || 'h(ä|ae)ufige fragen|faq', 'i'); }
    catch (e) { re = /h(ä|ae)ufige fragen|faq/i; }

    var heads = prose.querySelectorAll('h2');
    var start = null;
    for (var i = 0; i < heads.length; i++) {
      if (re.test(heads[i].textContent || '')) { start = heads[i]; break; }
    }
    if (!start) return;

    // Alles zwischen dieser und der nächsten h2 einsammeln.
    var block = [];
    var node = start.nextElementSibling;
    while (node && node.tagName !== 'H2') {
      block.push(node);
      node = node.nextElementSibling;
    }
    var hasQuestion = block.some(function (el) { return el.tagName === 'H3'; });
    if (!hasQuestion) return;

    var wrap = document.createElement('div');
    wrap.className = 'pfblog-faq';
    var current = null;

    block.forEach(function (el) {
      if (el.tagName === 'H3') {
        current = document.createElement('details');
        current.className = 'pfblog-faq-item';
        var summary = document.createElement('summary');
        summary.innerHTML = ICON_PLUS + '<span>' + el.textContent + '</span>';
        current.appendChild(summary);
        var body = document.createElement('div');
        body.className = 'pfblog-faq-body';
        current.appendChild(body);
        wrap.appendChild(current);
        el.parentNode.removeChild(el);
      } else if (current) {
        current.querySelector('.pfblog-faq-body').appendChild(el);
      }
    });

    if (wrap.children.length) start.parentNode.insertBefore(wrap, node);
  }

  /* ── Tipp-Kasten: Icon in Zitate setzen ────────────────────────────── */
  function decorateTips(prose) {
    prose.querySelectorAll('blockquote').forEach(function (bq) {
      if (bq.querySelector('.pfblog-tip-icon')) return;
      var holder = document.createElement('div');
      holder.innerHTML = ICON_TIP;
      var icon = holder.firstChild;
      var body = document.createElement('div');
      while (bq.firstChild) body.appendChild(bq.firstChild);
      bq.appendChild(icon);
      bq.appendChild(body);
    });
  }

  /* ── Inhaltsverzeichnis aus den h2 ─────────────────────────────────── */
  function buildToc(root, prose) {
    var lists = root.querySelectorAll('[data-pfblog-toc]');
    if (!lists.length) return [];

    var number = root.getAttribute('data-number-headings') === 'true';
    var heads = Array.prototype.slice.call(prose.querySelectorAll('h2'));
    var items = [];

    // Eigener Zähler: leere Überschriften (kommen in Altbeiträgen vor) werden
    // übersprungen und dürfen die Kapitelnummern nicht springen lassen.
    var nr = 0;
    heads.forEach(function (h) {
      var label = (h.textContent || '').trim();
      if (!label) return;
      nr += 1;
      if (!h.id) h.id = 'kap-' + slug(label, String(nr));
      if (number && !h.getAttribute('data-numbered')) {
        h.setAttribute('data-numbered', '1');
        label = nr + ' · ' + label;
        h.textContent = label;
      }
      items.push({ id: h.id, label: label, el: h });
    });

    if (items.length < 2) {
      root.querySelectorAll('[data-pfblog-toc-box]').forEach(function (box) { box.hidden = true; });
      return [];
    }

    lists.forEach(function (list) {
      list.innerHTML = '';
      items.forEach(function (item) {
        var a = document.createElement('a');
        a.href = '#' + item.id;
        a.textContent = item.label;
        list.appendChild(a);
      });
    });

    return items;
  }

  /* ── Mitlaufende Markierung + Lesefortschritt ──────────────────────── */
  function trackReading(root, article, items) {
    var bar = root.querySelector('[data-pfblog-progress] > i');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-pfblog-toc] a'));
    var ticking = false;

    function offset() {
      var raw = getComputedStyle(root).getPropertyValue('--pfblog-sticky');
      return (parseInt(raw, 10) || 0) + 90;
    }

    function update() {
      ticking = false;

      if (bar && article) {
        var box = article.getBoundingClientRect();
        var span = box.height - window.innerHeight;
        var read = span > 0 ? Math.min(1, Math.max(0, -box.top / span)) : (box.bottom <= window.innerHeight ? 1 : 0);
        bar.style.width = (read * 100).toFixed(1) + '%';
      }

      if (items.length && links.length) {
        var line = offset();
        var active = items[0].id;
        for (var i = 0; i < items.length; i++) {
          if (items[i].el.getBoundingClientRect().top <= line) active = items[i].id;
        }
        links.forEach(function (a) {
          a.classList.toggle('is-current', a.getAttribute('href') === '#' + active);
        });
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ── Teilen, Drucken, Merken ───────────────────────────────────────── */
  function wireActions(root) {
    var url = window.location.href;
    var title = root.getAttribute('data-title') || document.title;

    root.querySelectorAll('[data-pfblog-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var before = btn.getAttribute('aria-label');
            btn.setAttribute('aria-label', 'Link kopiert');
            btn.classList.add('is-done');
            setTimeout(function () {
              btn.setAttribute('aria-label', before);
              btn.classList.remove('is-done');
            }, 1800);
          }).catch(function () {});
        }
      });
    });

    root.querySelectorAll('[data-pfblog-print]').forEach(function (btn) {
      btn.addEventListener('click', function () { window.print(); });
    });

    var key = 'pfblog:merken:' + (root.getAttribute('data-handle') || '');
    root.querySelectorAll('[data-pfblog-save]').forEach(function (btn) {
      var saved = false;
      try { saved = window.localStorage.getItem(key) === '1'; } catch (e) {}
      btn.classList.toggle('is-active', saved);
      btn.addEventListener('click', function () {
        saved = !saved;
        btn.classList.toggle('is-active', saved);
        try {
          if (saved) window.localStorage.setItem(key, '1');
          else window.localStorage.removeItem(key);
        } catch (e) {}
      });
    });
  }

  function init(root) {
    if (root.getAttribute('data-pfblog-ready') === '1') return;
    root.setAttribute('data-pfblog-ready', '1');

    var article = root.querySelector('[data-pfblog-article]');
    var prose = root.querySelector('[data-pfblog-prose]');
    var items = [];

    if (prose) {
      if (root.getAttribute('data-faq') === 'true') buildFaq(prose, root.getAttribute('data-faq-pattern'));
      decorateTips(prose);
      items = buildToc(root, prose);
    }

    trackReading(root, article, items);
    wireActions(root);
  }

  function boot() {
    document.querySelectorAll('[data-pfblog-post]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme-Editor: Sektion neu geladen
  document.addEventListener('shopify:section:load', boot);
})();